/* tslint:disable:max-line-length */
import classNames from 'classnames';
import React from 'react';
import { IconTypeProps } from '../types';

export const FilterFilledIcon = ({
  className,
  style,
  color = '#3A50F3',
  onClick,
  ...rest
}: IconTypeProps) => {
  return (
    <svg
      className={classNames(className)}
      onClick={onClick}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      {...rest}
    >
      <g clipPath="url(#clip0)">
        <path
          d="M15.7811 1.28125L9.99982 7.06031V15.25C9.99982 15.8597 9.31232 16.2097 8.81982 15.8644L6.31982 14.1144C6.22102 14.0452 6.14035 13.9533 6.08464 13.8463C6.02894 13.7394 5.99984 13.6206 5.99982 13.5V7.0625L0.218575 1.28125C-0.250175 0.808437 0.0838876 0 0.749825 0H15.2498C15.9164 0 16.2498 0.809375 15.7811 1.28125Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
